import React from 'react';
import { Link } from 'react-router-dom'; // Importa Link para la navegación interna
import carousel1 from '../../assets/img/carousel-1.png';
import carousel2 from '../../assets/img/carousel-2.png';
import carousel3 from '../../assets/img/carousel-3.png';
import carousel4 from '../../assets/img/carousel-4.png';
import carousel5 from '../../assets/img/carousel-5.png';

const Carrusel = () => {
  return (
    <div className="container-fluid p-0">
      <div
        id="header-carousel"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="5000" // Añade esta línea para la configuración del intervalo
      >
        <div className="carousel-inner">
          {/* Primera diapositiva */}
          <div className="carousel-item active">
            <img className="w-100" src={carousel1} alt="Carousel 1" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: '900px' }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  Lo nuevo en tratamientos de ortodoncia.
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn">
                  Transforma tu sonrisa con #KeepSmiling
                </h1>
                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2">
                  <Link
                    to="/appointment"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInLeft"
                  >
                    Agendá tu turno
                  </Link>
                  <Link
                    to="/services"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInRight"
                  >
                    Más Info
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Segunda diapositiva */}
          <div className="carousel-item">
            <img className="w-100" src={carousel2} alt="Carousel 2" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: '900px' }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  Tecnología computarizada.
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn">
                  Llega a Lash odontología digital de vanguardia
                </h1>
                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2">
                  <Link
                    to="/appointment"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInLeft"
                  >
                    Agendá tu turno
                  </Link>
                  <Link
                    to="/services"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInRight"
                  >
                    Más Info
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Tercera diapositiva */}
          <div className="carousel-item">
            <img className="w-100" src={carousel3} alt="Carousel 3" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: '900px' }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  Periodoncia
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn">
                  Cuida tus encías, recupera la salud de tu boca y evita la gingivitis
                </h1>
                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2">
                  <Link
                    to="/appointment"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInLeft"
                  >
                    Agendá tu turno
                  </Link>
                  <Link
                    to="/services"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInRight"
                  >
                    Más Info
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Cuarta diapositiva */}
          <div className="carousel-item">
            <img className="w-100" src={carousel4} alt="Carousel 4" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: '900px' }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  Estética.
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn">
                  Aspectos Básicos del Blanqueamiento Dental
                </h1>
                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2">
                  <Link
                    to="/appointment"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInLeft"
                  >
                    Agendá tu turno
                  </Link>
                  <Link
                    to="/services"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInRight"
                  >
                    Más Info
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/*   Quinta diapositiva */}
          <div className="carousel-item">
            <img className="w-100" src={carousel5} alt="Carousel 5" />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: '900px' }}>
                <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                  Estética.
                </h5>
                <h1 className="display-1 text-white mb-md-4 animated zoomIn">
                  Aplicación de Botox y Ácido Hialurónico con la Dra. Suárez Fernández
                </h1>
                <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2">
                  <Link
                    to="/appointment"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInLeft"
                  >
                    Agendá tu turno
                  </Link>
                  <Link
                    to="/services"
                    className="btn btn-primary py-md-3 px-md-5 w-100 w-sm-auto animated slideInRight"
                  >
                    Más Info
                  </Link>
                </div>
              </div>
            </div>
          </div>
          </div>

        {/* Botón anterior */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Anterior</span>
        </button>
        {/* Botón siguiente */}
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Siguiente</span>
        </button>
      </div>
    </div>
  );
};

export default Carrusel;